import { useEffect, useState } from 'react';
import { STATUS_API_URL } from '../config/api.config';

interface ServiceStatusEntry {
  name: string;
  status: 'operational' | 'degraded' | 'not_configured';
  lastCheckedAt: string | null;
  lastChangedAt: string | null;
}

interface StatusResponse {
  overall: 'operational' | 'degraded' | 'unknown';
  lastRunAt: string | null;
  services: ServiceStatusEntry[];
}

/**
 * Reads StatusAPI's public /status feed. Deliberately fails silent — a
 * status checker that itself can't be reached shouldn't show up as a visible
 * problem on the login page or Support page.
 */
export function useServiceStatus() {
  const [status, setStatus] = useState<StatusResponse | null>(null);

  useEffect(() => {
    let cancelled = false;

    fetch(`${STATUS_API_URL}/status`)
      .then((res) => (res.ok ? res.json() : null))
      .then((data: StatusResponse | null) => {
        if (!cancelled) setStatus(data);
      })
      .catch(() => {
        if (!cancelled) setStatus(null);
      });

    return () => { cancelled = true; };
  }, []);

  return status;
}
